import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
        },
        controlsWrapper: {
            display: 'flex',
            justifyContent: 'space-around',
        },
    }
})

export default useStyles
